import React from "react";
import { motion } from "framer-motion";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Paragraph from "../components/Paragraph";

function ContactRoute() {
  React.useEffect(() => {
    document.title = "Anas A - Contact and more";
  }, []);
  return (
    <div className="flex gap-10">
      <Sidebar />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1}}
        className="py-20 pr-10 ml-0 md:ml-[240px]"
      >
        <div className="flex flex-col flex-1 overflow-y-auto overflow-x-hidden max-w-3xl">
          <div className="flex flex-col flex-1">
            <Header>
            Get in touch.
            </Header>
            <motion.div
        initial={{opacity:0, scale:0.4}}
        animate={{opacity:1, scale:1,}}
        
        transition={{
         duration: 0.6,
         delay: 0.4,
         ease: [0, 0.71, 0.2, 1.01]
       }}

            >
            <Paragraph>
              The best way of getting in contact with me is via E-Mail:{" "}
              <a
                className="custom-purple-color"
                href="mailto:anas.agrich.1@gmail.com"
                >
                anas.agrich.1@gmail.com
              </a>
              .
            </Paragraph>
                </motion.div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default ContactRoute;
